const OfferSpendCrudModalLangKey = [
	'title_create',
	'title_edit',
	'title_remove_single',
	'title_notes_view',
	'title_notes_edit',
	'title_history_view',
	'title_by_account',
	'title_by_account_total',
	'title_by_offer',
	'title_by_offer_total',
	'title_by_offer_scope',
	'title_by_offer_scope_total',
	'field_offer_label',
	'field_offer_placeholder',
	'field_user_label',
	'field_user_placeholder',
	'field_date_label',
	'field_date_placeholder',
	'field_amount_label',
	'field_amount_placeholder',
	'field_notes_label',
	'field_notes_placeholder',
	'msg_remove_confirm',
	'btn_create',
	'btn_update',
	'btn_remove',
	'btn_close'
] as const

type IOfferSpendCrudModalLangKey = typeof OfferSpendCrudModalLangKey[number]

export type IOfferSpendCrudModalLang = {
	offer_spend_crud_modal: Record<IOfferSpendCrudModalLangKey, string>
}

const langEntries = OfferSpendCrudModalLangKey.map(
	(key: IOfferSpendCrudModalLangKey) => [key, `offer_spend_crud_modal.${key}`]
)

const langObj: Record<IOfferSpendCrudModalLangKey, string> = Object.fromEntries(langEntries)

export const OFFER_SPEND_CRUD_MODAL_LANG_KEY: IOfferSpendCrudModalLang = {
	offer_spend_crud_modal: langObj
}